import { borderRadius, typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const Root = styled.div`
  ${borderRadius.r2}
  border: 1px solid var(--border-soft);
  padding-top: 34px;
  padding-bottom: 34px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Title = styled.div`
  ${typographyV2.bodyBase};
  padding-top: 8px;
  padding-bottom: 4px;
`;

export const Description = styled.div`
  ${typographyV2.bodySm};
  color: var(--text-soft);
`;
